// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 8926 ? "react-monaco-editor" : chunkId) + "." + {"3260":"6694a50a","8926":"62a553fe","9677":"82b45cb8"}[chunkId] + ".chunk.css";
};